export const AUTH_LAST_AUTHENTICATION_STRATEGY_KEY = '__auth_last_authentication_strategy';

/**
 * Clerk updates `client.lastAuthenticationStrategy` to `email_address` when
 * `signIn.create({ identifier })` runs during an in-progress sign-in attempt.
 * These values are not the user's last completed auth method.
 */
export const TRANSIENT_LAST_AUTHENTICATION_STRATEGIES = new Set(['email_address']);

export function persistLastAuthenticationStrategy(strategy: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(AUTH_LAST_AUTHENTICATION_STRATEGY_KEY, strategy);
}

export function getPersistedLastAuthenticationStrategy(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return localStorage.getItem(AUTH_LAST_AUTHENTICATION_STRATEGY_KEY);
}

export function resolveLastAuthenticationStrategy(clerkStrategy: string | null | undefined): string | null {
  const persisted = getPersistedLastAuthenticationStrategy();

  if (persisted) {
    return persisted;
  }

  if (clerkStrategy && !TRANSIENT_LAST_AUTHENTICATION_STRATEGIES.has(clerkStrategy)) {
    persistLastAuthenticationStrategy(clerkStrategy);
    return clerkStrategy;
  }

  return null;
}

export function isLastUsedAuthenticationStrategy(lastStrategy: string | null, matchStrategy: string): boolean {
  return lastStrategy === matchStrategy;
}
